import * as React from 'react';
import { useCallback } from 'react';
import { MultiPosting } from './MultiPosting';
import { useMultiPostingDescription } from '../../../../hooks';
import { useAppContext } from '../../../../../AppModulesWrapper';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsMultiPostingEnabled } from '../../../../selectors/offer';
import { getLabelText } from '../../../../utils/multiposting/getLabelText';
import { selectIsMultiPostingAvailable, selectMultipostingABGroup } from '../../../../selectors/publishTerms';
import { changeMultiPostingEnabled } from '../../../../actions/offer';
import { selectIsMobileLayout } from '../../../../selectors/layout';

/**
 * MultiPostingContainer Кажется, что он больше не показывается пользователям, можно удалить
 * @deprecated
 */
export function MultiPostingContainer() {
  const dispatch = useDispatch();
  const { config } = useAppContext();
  const freeDate = config.get<string>('multiPosting.freeDate');
  const abGroup = useSelector(selectMultipostingABGroup);
  const text = useMultiPostingDescription();
  const termsUrl = String(config.get('addformConfig.multiPosting.termsUrl'));
  const isMultiPostingAvailable = useSelector(selectIsMultiPostingAvailable);
  const isMultiPostingChecked = useSelector(selectIsMultiPostingEnabled);
  const isMobile = useSelector(selectIsMobileLayout);

  const labelText = getLabelText(freeDate, abGroup);

  const handleChange = useCallback(
    (checked: boolean) => {
      dispatch(changeMultiPostingEnabled(checked));
    },
    [dispatch],
  );

  if (!isMultiPostingAvailable) {
    return null;
  }

  return (
    <MultiPosting
      isMobile={isMobile}
      checked={isMultiPostingChecked}
      text={text}
      labelText={labelText}
      termsUrl={termsUrl}
      onChange={handleChange}
    />
  );
}
